import { FC, Fragment } from "react";
import clsx from "clsx";
import { ExplorerItem } from "./ExplorerItem";

interface IProps {
  path?: any;
  currentId?: string;
  pathSeparator?: any;
  setFolderPath?: any;
}

export const Breadcrumbs: FC<IProps> = ({
  path,
  currentId,
  pathSeparator,
  setFolderPath,
}) => {
  const breadcrumbs = path?.split(pathSeparator) ?? [];
  const breadcrumbsId = currentId?.split(pathSeparator) ?? [];

  return (
    <div className="explorer-breadcrumbs__wrapper">
      {breadcrumbs.map((b: any, i: any) => {
        const isLast = i === breadcrumbs.length - 1;
        let displayName = b;
        try {
          displayName = decodeURIComponent(b);
        } catch {}

        return (
          <Fragment key={b}>
            {i > 0 && <span> ➤ </span>}
            <div
              onClick={
                !isLast
                  ? () =>
                      setFolderPath(
                        breadcrumbs.slice(0, i + 1).join(pathSeparator),
                        breadcrumbsId.slice(0, i + 1).join(pathSeparator)
                      )
                  : undefined
              }
              className={clsx("ellipsis", { clickable: !isLast })}
            >
              {displayName}
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};

interface IProps2 {
  path: string;
  currentId?: string;
  items: any;
  onSelect?: Function;
  setFolderPath: any;
}

export const FilesExplorer: FC<IProps2> = ({
  path,
  currentId,
  items,
  onSelect,
  setFolderPath,
}) => {
  return (
    <div className="explorer-area">
      <Breadcrumbs
        path={path}
        currentId={currentId}
        pathSeparator={"/"}
        setFolderPath={setFolderPath}
      />

      <header id="explorer-header">
        <div
          className="explorer-column"
          style={{ flexBasis: "30%", paddingLeft: 50 }}
        >
          <span>{"Name"}</span>
        </div>
        <div className="explorer-column" style={{ width: 90 }}>
          <span>{"Type"}</span>
        </div>
        <div className="explorer-column" style={{ width: 100 }}>
          <span>{"Size"}</span>
        </div>
      </header>

      {items.length > 0 ? (
        <ul
          tabIndex={1}
          id="explorer-list"
          className={"explorer-list filefolder-icons"}
        >
          {items.map((item: any) => (
            <ExplorerItem
              currentPath={path}
              currentId={currentId}
              item={item}
              key={item.type + "_" + item.id}
              onSelect={onSelect}
            />
          ))}
        </ul>
      ) : (
        <div className="explorer-empty-folder-msg">Folder is empty</div>
      )}
    </div>
  );
};
